import AxiosInstance from 'utils/AxiosInstance'
/*eslint-disable */

import * as types from './constants'

const question = {
	name: '',
	points: 1,
	options: [],
}

const bool = [
	{ name: 'True', value: 1, description: '', isDescriptionActive: false },
	{ name: 'False', value: 2, description: '', isDescriptionActive: false },
]

const multiple = [
	{ name: '', value: 1 },
	{ name: '', value: 2 },
]

export const fetchAllQuestions = () => {
	return (dispatch, getState) => {
		// const { test } = getState().questionBank

		AxiosInstance.get(`/question-bank`).then((data) => {
			dispatch({ type: types.SET_QUESTIONS, payload: data })
		})
	}
}

export const fetchAllFoldersFromQuestionBank = () => {
	return (dispatch, getState) => {
		AxiosInstance.get(`/question-bank/question-bank-folders`).then((data) => {
			dispatch({ type: types.SET_ALL_FOLDERS_QUESTIONS, payload: data })
		})
	}
}

export const saveQuestion = (data) => {
	return (dispatch, getState) => {
		AxiosInstance.post(`/question-bank`, { ...data }).then((data) => {
			const { openedFolder } = getState().questionBank

			if (openedFolder && openedFolder.id) {
				dispatch(getFolderQuestions(openedFolder.id))
			} else {
				dispatch(fetchAllQuestions())
			}
		})
	}
}

export const deleteQuestion = (id) => {
	return (dispatch, getState) => {
		const { openedFolder } = getState().questionBank
		let language = {}
		getState().language.language
			? (language = getState().language.language.data)
			: null
		if (
			confirm(language.alerts ? language.alerts.delete_question_confirm : null)
		) {
			AxiosInstance.delete(`/question-bank/${id}`).then((data) => {
				if (openedFolder && openedFolder.id) {
					dispatch(getFolderQuestions(openedFolder.id))
				} else {
					dispatch(fetchAllQuestions())
				}
			})
		}
	}
}

export const editQuestion = (data) => {
	return (dispatch, getState) => {
		const { openedFolder } = getState().questionBank
		AxiosInstance.put(`/question-bank/${data.id}`, { data }).then((data) => {
			if (openedFolder && openedFolder.id) {
				dispatch(getFolderQuestions(openedFolder.id))
			} else {
				dispatch(fetchAllQuestions())
			}
		})
	}
}

export const setFolderTitle = (title) => {
	return (dispatch, getState) => {
		dispatch({ type: types.SET_FOLDER_TITLE, payload: title })
	}
}

// export const updateFolderTitle = (title) => {
// 	return (dispatch, getState) => {
// 		dispatch({ type: types.SET_FOLDER_TITLE, payload: title })
// 	}
// }

// export const createNewFolder = () => {

// }

export const onSelectFolderThumb = (thumbFile) => {
	return (dispatch, getState) => {
		const fileReader = new FileReader()

		fileReader.onload = (evt) => {
			dispatch({ type: types.FOLDER_THUMBNAIL, payload: evt.target.result })
		}

		fileReader.readAsDataURL(thumbFile)

		dispatch({ type: types.FOLDER_THUMBNAIL_FILE, payload: thumbFile })
	}
}

export const toggleQuestions = (id) => {
	return (dispatch, getState) => {
		const { folderSelectedQuestions } = getState().questionBank

		const index = folderSelectedQuestions.findIndex((item) => item === id)

		if (index === -1) {
			dispatch({
				type: types.SET_FOLDER_SELECTED_QUESTIONS,
				payload: [...folderSelectedQuestions, id],
			})

			return
		}

		const newCourses = [
			...folderSelectedQuestions.slice(0, index),
			...folderSelectedQuestions.slice(index + 1),
		]

		dispatch({ type: types.SET_FOLDER_SELECTED_QUESTIONS, payload: newCourses })
	}
}

export const createNewFolder = () => {
	return (dispatch, getState) => {
		const { folderTitle } = getState().questionBank

		// const nodes = event.target.elements

		// const thumbInput = [].filter.call(nodes, (item) => item.type === 'file')[0]

		// const thumb = thumbInput.files[0]
		if (!folderTitle) {
			alert('Please type the name of the folder')
			return
		}

		const data = new FormData()
		data.append('folderTitle', folderTitle)

		AxiosInstance.post(`/question-bank/add-folder`, data)

			.then((data) => {
				dispatch(fetchAllFoldersFromQuestionBank())
			})
			.catch((err) => {
				console.log(err)
			})
	}
}

export const editFolder = () => {
	return (dispatch, getState) => {
		const { folderTitle, editingFolder } = getState().questionBank

		// const nodes = event.target.elements

		// const thumbInput = [].filter.call(nodes, (item) => item.type === 'file')[0]

		const data = { name: folderTitle, id: editingFolder.id }

		// const thumb = thumbInput.files[0]
		if (!folderTitle) {
			alert('Please type the name of the folder')
			return
		}

		AxiosInstance.put(`/question-bank/edit-folder/${data.id}`, { data })
			.then((data) => {
				dispatch({ type: types.SET_EDIT_FOLDER, payload: null })
				// dispatch({ type: types.SET_ADD_FOLDER_TOGGLE })
				// dispatch({ type: types.SET_RENAME_FOLDER })
				dispatch(setOpenedFolder(data[0]))
				dispatch(fetchAllFoldersFromQuestionBank())
				dispatch({ type: types.SET_FOLDER_TITLE, payload: '' })
			})
			.catch((err) => {
				console.log(err)
			})
	}
}

export const setOpenMoveQuestion = (id) => {
	return (dispatch, getState) => {
		const { questions } = getState().questionBank

		const questionMoveIndex = questions.findIndex(
			(question) => question.id == id
		)

		const questionMove = questions[questionMoveIndex]

		if (questionMove.openMove) {
			questionMove.openMove = false
			dispatch({ type: types.SET_OPEN_MOVE_QUESTION, payload: '' })
		} else {
			questionMove.openMove = true
			dispatch({ type: types.SET_OPEN_MOVE_QUESTION, payload: questionMove.id })
		}

		questions[questionMoveIndex] = questionMove

		dispatch({ type: types.SET_QUESTIONS, payload: questions })
	}
}

export const moveQuestionOnChange = (event) => {
	const folderToMove = event.target.value

	return (dispatch, getState) => {
		const { openMoveQuestion, questions, openedFolder } =
			getState().questionBank

		const questionMoveIndex = questions.findIndex(
			(question) => question.id == openMoveQuestion
		)

		const closeMove = questions[questionMoveIndex]
		closeMove.openMove = false

		questions[questionMoveIndex] = closeMove

		dispatch({ type: types.SET_QUESTIONS, payload: questions })

		const data = { folderId: folderToMove, questionId: openMoveQuestion }

		if (openedFolder) {
			AxiosInstance.post(`/question-bank/update-question-folder`, data)

				.then(({ data }) => {
					dispatch(getFolderQuestions(openedFolder.id))
				})
				.catch((err) => {
					console.log(err)
				})
		} else {
			AxiosInstance.post(`/question-bank/add-question-folder`, data)
				.then(({ data }) => {
					dispatch(fetchAllQuestions())
				})
				.catch((err) => {
					console.log(err)
				})
		}
	}
}

export const setOpenedFolder = (folder) => {
	return (dispatch, getState) => {
		const { questions } = getState().questionBank

		dispatch({ type: types.SET_OPENED_FOLDER, payload: folder })

		dispatch(getFolderQuestions(folder.id))

		// apiNode
		// 	.get(`/question-bank/folder-questions/${folder.id}`)
		// 	.then((data) => {
		// 		console.log(data, 'data')

		// 		dispatch({ type: types.SET_QUESTIONS, payload: data })
		// 	})
		// 	.catch((err) => {
		// 		console.log(err)
		// 	})
	}
}

export const getFolderQuestions = (id) => {
	return (dispatch, getState) => {
		AxiosInstance.get(`/question-bank/folder-questions/${id}`)
			.then((data) => {
				dispatch({ type: types.SET_QUESTIONS, payload: data })
			})
			.catch((err) => {
				console.log(err)
			})
	}
}

export const setCloseFolder = () => {
	return (dispatch, getState) => {
		dispatch({ type: types.SET_OPENED_FOLDER, payload: null })

		AxiosInstance.get(`/question-bank`)
			.then((data) => {
				dispatch({ type: types.SET_QUESTIONS, payload: data })
			})
			.catch((err) => {
				console.log(err)
			})
	}
}

export const setEditFolder = (folder) => {
	return (dispatch, getState) => {
		const { editingFolder, toggleEditFolder } = getState().questionBank

		if (toggleEditFolder) {
			dispatch({ type: types.SET_TOGGLE_EDIT_FOLDER, payload: false })
		} else {
			dispatch({ type: types.SET_TOGGLE_EDIT_FOLDER, payload: true })
		}

		dispatch({ type: types.SET_FOLDER_TITLE, payload: '' })
		dispatch({ type: types.SET_EDIT_FOLDER, payload: folder })
	}
}

export const renameFolder = () => {
	return (dispatch, getState) => {
		const { editingFolder, toggleEditFolder } = getState().questionBank
		dispatch({ type: types.SET_RENAME_FOLDER })

		if (toggleEditFolder) {
			dispatch({ type: types.SET_TOGGLE_EDIT_FOLDER, payload: false })
		} else {
			dispatch({ type: types.SET_TOGGLE_EDIT_FOLDER, payload: true })
		}
	}
}

export const handleAddFolderToggle = () => {
	return (dispatch, getState) => {
		const { renameFolder } = getState().questionBank

		if (renameFolder) {
			dispatch({ type: types.SET_RENAME_FOLDER })
		} else {
			dispatch({ type: types.SET_ADD_FOLDER_TOGGLE })
		}
	}
}

export const deleteFolder = (folder) => {
	return (dispatch, getState) => {
		// const {editingFolder} =getState().questionBank

		AxiosInstance.delete(`/question-bank/delete-folder/${folder.id}`).then(
			(data) => {
				dispatch(fetchAllFoldersFromQuestionBank())
				dispatch({ type: types.SET_OPENED_FOLDER, payload: null })
				dispatch({ type: types.SET_TOGGLE_EDIT_FOLDER, payload: false })
			}
		)
	}
}
